import apiClient from './client';
import { Account } from '../types';

export const accountsApi = {
  getAll: () =>
    apiClient.get<Account[]>('/v1/accounts').then((r) => r.data),

  getOne: (accountId: string) =>
    apiClient.get<Account>(`/v1/accounts/${accountId}`).then((r) => r.data),

  getGroups: () =>
    apiClient.get<string[]>('/v1/accounts/groups').then((r) => r.data),
};
